import { observer } from 'mobx-react-lite'
import { useModals } from 'almanac-ui/Modal'
import { useRootStore } from 'stores/RootStore'
import { BaseNextStep } from './BaseNextStep'
import { TurnIntoWizard } from 'components/Wizards/TurnInto/TurnIntoWizard'
import { SourceType } from 'components/Wizards/TurnInto/Source/Types'
import { useAlmanacEditorState } from 'stores/EditorState'
import { markdownSerializer } from 'common/Prose/components/TextInlineFormatBar/components/FormatBars/markdownSerializer'
import { TurnInto } from 'blaze-ui/icons'
import { usePaywallGuard } from 'hooks/usePaywallGuard'

export const NewGenerationNextStep = observer(function NewGenerationNextStep() {
  const { openModal } = useModals()
  const { docStore } = useRootStore()
  const stateContext = useAlmanacEditorState()

  const handleCampaignPress = () => {
    docStore?.rightRailStore.setActiveTab(undefined)

    const doc = stateContext?.view.state.doc

    const documentAsMarkdown = doc ? markdownSerializer.serialize(doc) : undefined

    openModal(TurnIntoWizard, {
      initialIsCampaign: true,
      sourceType: SourceType.File,
      fromDocProps: { documentAsMarkdown },
    })
  }

  const guardedHandleCampaignPress = usePaywallGuard(handleCampaignPress)

  return (
    <BaseNextStep
      className="social-media-doc-tour-4"
      actionText="Turn this doc into 50+ content types"
      icon={<TurnInto size={40} />}
      onPress={guardedHandleCampaignPress}
    />
  )
})
